import React from 'react';
import {
    withStyles,
    Grid,
    IconButton,
    AppBar,
} from '@material-ui/core';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

class MArrowBack extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { classes, sytle } = this.props;
        return (
            <AppBar className={classes.appbar}>
                <Grid justifyContent='space-between' container>
                    <IconButton onClick={() => window.history.back()}>
                        <ArrowBackIosIcon className={classes.arrowIcon} style={sytle} />
                    </IconButton>
                </Grid>
            </AppBar>
        );
    }
}

export default withStyles((theme) => ({
    appbar: {
        top: 0,
        backgroundColor: 'transparent',
        height: 48,
        boxShadow: 'none'
    },
    arrowIcon: {
        fontSize: 17,
        color: '#0D0D0D',
        marginLeft: 10,
        marginTop: 10,
    }
}))(MArrowBack);